var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 9.99996H10.0087M10.0003 4.99996H10.0087M10.0003 15H10.0087M10.8337 9.99996C10.8337 10.4602 10.4606 10.8333 10.0003 10.8333C9.54008 10.8333 9.16699 10.4602 9.16699 9.99996C9.16699 9.53971 9.54008 9.16663 10.0003 9.16663C10.4606 9.16663 10.8337 9.53971 10.8337 9.99996ZM10.8337 15C10.8337 15.4602 10.4606 15.8333 10.0003 15.8333C9.54008 15.8333 9.16699 15.4602 9.16699 15C9.16699 14.5397 9.54008 14.1666 10.0003 14.1666C10.4606 14.1666 10.8337 14.5397 10.8337 15ZM10.8337 4.99996C10.8337 5.46019 10.4606 5.83329 10.0003 5.83329C9.54008 5.83329 9.16699 5.46019 9.16699 4.99996C9.16699 4.53973 9.54008 4.16663 10.0003 4.16663C10.4606 4.16663 10.8337 4.53973 10.8337 4.99996Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.bd64777893e32a52e975ad2fbbf75978.svg";
export { ForwardRef as ReactComponent };